import { cn } from '@/lib/utils';

interface WidgetWrapperProps {
  readonly children: React.ReactNode;
  readonly colSpan?: 1 | 2 | 3 | 4 | 5 | 6;
  readonly className?: string;
}

export function WidgetWrapper({ children, colSpan = 2, className }: WidgetWrapperProps) {
  const colSpanClasses = {
    1: 'col-span-1',
    2: 'col-span-2 md:col-span-2',
    3: 'col-span-2 md:col-span-3 xl:col-span-3',
    4: 'col-span-2 md:col-span-4 xl:col-span-4',
    5: 'col-span-2 md:col-span-4 xl:col-span-5',
    6: 'col-span-2 md:col-span-4 xl:col-span-6',
  };

  return (
    <div className={cn(colSpanClasses[colSpan], 'flex', className)}>
      <div className="w-full">
        {children}
      </div>
    </div>
  );
}
